
export const LOCATION_FORM_OBJECT = {
    cityField: "consigneeCity",
    zipField: "consigneeZip",
    destinationField: "pickupTerminal",
    stateField: "consigneeState",
    cityLabel: "City",
    zipLabel: "Zipcode",
    stateLabel: "State",
    destinationLabel: "Pickup Terminal",
};

export const CURRENT_LOCATION_FORM_OBJECT = {
    cityField: "currentLocationCity",
    zipField: "currentLocationZip",
    stateField: "currentLocationState",
    cityLabel: "City",
    zipLabel: "Zipcode",
    stateLabel: "State",
    destinationField: "pickupTerminal",
    destinationLabel: "Pickup Terminal",
};

export const EMERGENCY_CONTACT_NUMBER = "800-580-4632";